import { render, staticRenderFns } from "./PersonsContent.vue?vue&type=template&id=89929de6&scoped=true&"
import script from "./PersonsContent.vue?vue&type=script&lang=js&"
export * from "./PersonsContent.vue?vue&type=script&lang=js&"
import style0 from "./PersonsContent.vue?vue&type=style&index=0&id=89929de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89929de6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89929de6')) {
      api.createRecord('89929de6', component.options)
    } else {
      api.reload('89929de6', component.options)
    }
    module.hot.accept("./PersonsContent.vue?vue&type=template&id=89929de6&scoped=true&", function () {
      api.rerender('89929de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/persons/PersonsContent.vue"
export default component.exports